import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';

const Surcharges = lazy(() => import('~/apps/surcharges/surcharges'));

export default function Component() {
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SURCHARGES);

  useOnLoad(() => {
    const title = t('SURCHARGES_PAGE_TITLE', { defaultValue: 'Courier Surcharges' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SURCHARGES });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Surcharges }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Surcharges
      }
    });
  });

  return (
    <Tagged tag="screen-surcharges">
      <Suspense>
        <Surcharges />
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'Surcharges';
